function isSelectionCollapsed(anchorOffset, focusOffset) {
  return anchorOffset === focusOffset;
}
export default isSelectionCollapsed;
